import { CheckoutApiError } from '../../api'
import type { CheckoutFlowErrorCode } from '../CheckoutFlow.types'

export const resolveSubmitError = ({
  error,
  fallbackCode,
}: {
  error: unknown
  fallbackCode: CheckoutFlowErrorCode
}): { code: CheckoutFlowErrorCode; detail: string } => {
  if (error instanceof CheckoutApiError) {
    const detail = error.message.trim()
    const normalized = detail.toLowerCase()
    const isExpired = error.status === 409 && (normalized.includes('scadut') || normalized.includes('expired'))
    if (isExpired) return { code: 'session_expired', detail }
    if (error.status === 400 || error.status === 409) return { code: 'backend_validation_error', detail }
    return { code: fallbackCode, detail }
  }

  if (error instanceof Error && error.message.trim()) {
    return { code: fallbackCode, detail: error.message }
  }

  return { code: fallbackCode, detail: '' }
}
